/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>world-view-container.component.ts</name>
///
/// <description>
/// A component that presents the worldview of fusion sites
/// </description>
///
/// <author>Michael Martinez</author>
/// <created>23 Aug 2017</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 23Aug17 MM  1.0.0000         First cut
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
///
import {Component, OnInit, Input, Output, EventEmitter} from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";
import { Http, RequestOptions, Headers, Response } from '@angular/http';
import {Subscription} from "rxjs/Subscription";
import {Observable} from "rxjs/Observable";
import {HostListener} from '@angular/core';
import { hydUtilService} from "../../../utils/hydUtils.service";
import {Accordion, AccordionTab, MenuItem} from "primeng/primeng";


import {MediatorService} from "../../../services/mediator.service";
import {MediatorEventLookup} from "../../../services/mediator-event-lookup.service";

import {CUIFeatureInterface} from  "../../../interfaces/cui-feature.interface";

import {TranslatedStringsService } from '../../../services/language.service';

 import  *   as pbi from 'powerbi-client';
//import *  as amc from 'amcharts3';
//import *  as amc from 'ammap3';

import {
    App,
    Adapter,
    Addresses,
    AirMedia,
    AudioDevices,
    AudioVideoInputOutput,
    AutoUpdateMaster,
    Credentials,
    Background,
    Bluetooth,
    CustomBackground,
    Device,
    DeviceList,
    DevicesSearch,
    DeviceOperation,
    DeliveryStateEnum,
    DeviceApiService,
    DownstreamEdid,
    Ethernet,
    FusionSetup,
    FusionCloud,
    General,
    Hdmi,
    IPAddr,
    InputOutput,
    LicenseRegistry,
    Logo,
    MergeAction,
    OperationStateEnum,
    OperationEnum,
    Port,
    Scheduling,
    SIP,
    Settings as AVFSettings,
    Speedkey,
    Sntp,
    SystemVersions,
    SystemClock,
    RunTimeSettings,
    TimeOptions,
    USB,
    VideoDisplay,
    SFB,
    Preset,
    ConnectionDisplayOptions,
    ThirdPartyApplications,
    ZoomRoom,
    DeviceRequest
} from '../../../services/Crestron.HydrogenAPI.DeviceApi.service';

import {
    Background as GroupBackground,
    GroupApiService,
    Settings as GroupAVFSettings,
    GroupAPI,
    Group,
    Policy,
    GroupsSearch,
    GroupAPIRequest} from '../../../services/Crestron.HydrogenAPI.GroupApi.service';


import { DashboardAPIService } from '../../../services/Crestron.HydrogenAPI.DashboardTokenApi.service';
import { HydUser } from '../../../models/user';
 
declare let objectPath: any;
declare let jQuery: any;
declare let powerbi: any;
declare let AmCharts: any;

@Component({
  selector: "world-view-container",
  templateUrl: "./world-view-container.component.html",
  styleUrls: ["./world-view-container.component.css"]
})
export class WorldViewContainerComponent implements CUIFeatureInterface {


  private busyLoading: any; 
  private map: any;

    constructor (
       private mediatorService: MediatorService,
       private i18n: TranslatedStringsService,
       private route: ActivatedRoute,
       private http: Http, 
      private hydUser: HydUser 
    ) {

    }

    //----------------------------------------------------------
    //Implementations of Interface
    //----------------------------------------------------------

    //ngOnInit(){  };
    ngDoCheck() { };
    ngAfterContentInit() { };
    ngAfterContentChecked() { };

    ngAfterViewChecked() { };


    //----------------------------------------------------------
    //ngOnInit
    //----------------------------------------------------------
    ngOnInit() {

        try {

            this.Start();

        }
        catch (e) {
            console.log("Error-->ngOnInit()");
        }

    }

    //----------------------------------------------------------
    //ngAfterViewInit
    //----------------------------------------------------------
    ngAfterViewInit() {


     

      //jQuery.ajax({
      //  type: "GET",
      //  url: "http://fcp002pwc010.eastus.cloudapp.azure.com/fusionstats/api/FusionStatsLocationSummary",
      //  contentType: "application/json; charset=utf-8",
      //  dataType: "json",
      //  data: '{}',
      //  processData: false,
      //  error: function (XMLHttpRequest, textStatus, errorThrown) {
      //    console.log("GetFusionStatsSummary:" + errorThrown);
           
      //  },
      //  success: function (result) {
      //    var res = result[0];

           
      //  }
      //});

    }

    //----------------------------------------------------------
    //ngOnDestroy
    //----------------------------------------------------------
    ngOnDestroy() {


      try {

        if (this.map) {
             AmCharts.destroyChart(this.map);
        }

        }
        catch(e) {
            console.log("Error-->ngOnDestroy()");
        }
    }


    //----------------------------------------------------------
    //ngOnChanges
    //----------------------------------------------------------
    ngOnChanges(changes: any) {

    }



    //----------------------------------------------------------
    //translate
    //----------------------------------------------------------
    translate() {

        try{
         
        }
        catch(e) {
            console.log("Error-->translate()");
        }
    }
   



    //----------------------------------------------------------
    //Start
    //----------------------------------------------------------
    private Start() {

        try {
            this.translate();
            this.refreshData();   
            this.loadMap();

        }
        catch(e) {
            console.log("Error-->Start()");
        }

    };




    //-----------------------------------------------
    // refreshData
    //-----------------------------------------------
    private refreshData( ) {

      try {
 

        }
        catch(e) {
            console.log("Error-->refreshData()");
        }


    }
   


    //----------------------------------------------------------
    //loadMap
    //----------------------------------------------------------
    private loadMap() {
        try { 
 
          this.map = AmCharts.makeChart("worldView", {
            "type": "map",
            "theme": "black",
            "projection": "miller",

            "imagesSettings": {
              "rollOverColor": "#089282",
              "rollOverScale": 3,
              "selectedScale": 3,
              "selectedColor": "#089282",
              "color": "#13564e"
            },

            "areasSettings": {
              "unlistedAreasColor": "#15A892"
            },

            "dataProvider": {
              "map": "worldLow",
              "images": [
                {
                "zoomLevel": 5,
                "scale": 0.5,
                "title": "Brussels",
                "latitude": 50.8371,
                "longitude": 4.3676
              }, {
                "zoomLevel": 5,
                "scale": 0.5,
                "title": "Copenhagen",
                "latitude": 55.6763,
                "longitude": 12.5681
              }, {
                "zoomLevel": 5,
                "scale": 0.5,
                "title": "Paris",
                "latitude": 48.8567,
                "longitude": 2.3510
              }, {
                "zoomLevel": 5,
                "scale": 0.5,
                "title": "Reykjavik",
                "latitude": 64.1353,
                "longitude": -21.8952
              }, {
                "zoomLevel": 5,
                "scale": 0.5,
                "title": "Moscow",
                "latitude": 55.7558,
                "longitude": 37.6176
              }, {
                "zoomLevel": 5,
                "scale": 0.5,
                "title": "Madrid",
                "latitude": 40.4167,
                "longitude": -3.7033
              }, {
                "zoomLevel": 5,
                "scale": 0.5,
                "title": "London",
                "latitude": 51.5002,
                "longitude": -0.1262,
                "url": "http://www.google.co.uk"
              }, {
                "zoomLevel": 5,
                "scale": 0.5,
                "title": "Peking",
                "latitude": 39.9056,
                "longitude": 116.3958
              }, {
                "zoomLevel": 5,
                "scale": 0.5,
                "title": "New Delhi",
                "latitude": 28.6353,
                "longitude": 77.2250
              }, {
                "zoomLevel": 5,
                "scale": 0.5,
                "title": "Tokyo",
                "latitude": 35.6785,
                "longitude": 139.6823,
                "url": "http://www.google.co.jp"
              }, {
                "zoomLevel": 5,
                "scale": 0.5,
                "title": "Ankara",
                "latitude": 39.9439,
                "longitude": 32.8560
              }, {
                "zoomLevel": 5,
                "scale": 0.5,
                "title": "Buenos Aires",
                "latitude": -34.6118,
                "longitude": -58.4173
              }, {
                "zoomLevel": 5,
                "scale": 0.5,
                "title": "Brasilia",
                "latitude": -15.7801,
                "longitude": -47.9292
              }, {
                "zoomLevel": 5,
                "scale": 0.5,
                "title": "Ottawa",
                "latitude": 45.4235,
                "longitude": -75.6979
              }, {
                "zoomLevel": 5,
                "scale": 0.5,
                "title": "Washington",
                "latitude": 38.8921,
                "longitude": -77.0241
              }, {
                "zoomLevel": 5,
                "scale": 0.5,
                "title": "Kinshasa",
                "latitude": -4.3369,
                "longitude": 15.3271
              }, {
                "zoomLevel": 5,
                "scale": 0.5,
                "title": "Cairo",
                "latitude": 30.0571,
                "longitude": 31.2272
              }, {
                "zoomLevel": 5,
                "scale": 0.5,
                "title": "Pretoria",
                "latitude": -25.7463,
                "longitude": 28.1876
              }]
            }
          });

          let inst = this;
          // add events to recalculate map position when the map is moved or zoomed
          this.map.addListener("positionChanged", function (event) {
            // get map object
            var map = event.chart;

            // go through all of the images
            for (var x in map.dataProvider.images) {
              // get MapImage object
              var image = map.dataProvider.images[x];

              // check if it has corresponding HTML element
              if ('undefined' == typeof image.externalElement)
                image.externalElement =  inst.createCustomMarker(image);

              // reposition the element accoridng to coordinates
              var xy = map.coordinatesToStageXY(image.longitude, image.latitude);
              image.externalElement.style.top = xy.y + 'px';
              image.externalElement.style.left = xy.x + 'px';
            }


          });



        }
        catch (e) {
          console.log("Error-->loadMap(): " + e.message);

        }
    }

    


      //-----------------------------------------------
      // UpdateBusyControl
      //-----------------------------------------------
      private UpdateBusyControl() {

          let delay: number = 100;
          let minDuration: number = 900;

          //this.busyLoading = {
          //    busy: [  this.loadReportTokenSubscription],
          //    message: this.i18n.translate("busy-loading"),
          //    delay: delay,
          //    minDuration: minDuration
          //};
      }
    

  /**
 * This example uses pulsating circles CSS by Kevin Urrutia
 * http://kevinurrutia.tumblr.com/post/16411271583/creating-a-css3-pulsating-circle
 */

  
    // this function will take current images on the map and create HTML elements for them
    private updateCustomMarkers(event) {
      // get map object
      var map = event.chart;

      // go through all of the images
      for (var x in map.dataProvider.images) {
        // get MapImage object
        var image = map.dataProvider.images[x];

        // check if it has corresponding HTML element
        if ('undefined' == typeof image.externalElement)
          image.externalElement = this.createCustomMarker(image);

        // reposition the element accoridng to coordinates
        var xy = map.coordinatesToStageXY(image.longitude, image.latitude);
        image.externalElement.style.top = xy.y + 'px';
        image.externalElement.style.left = xy.x + 'px';
      }
    }

    // this function creates and returns a new marker element
  private createCustomMarker(image) {
      // create holder
      var holder = document.createElement('div');
      holder.className = 'map-marker';
      holder.title = image.title;
      holder.style.position = 'absolute';

      // maybe add a link to it?
      if (undefined != image.url) {
        holder.onclick = function () {
          window.location.href = image.url;
        };
        holder.className += ' map-clickable';
      }

      // create dot
      var dot = document.createElement('div');
      dot.className = 'dot';
      holder.appendChild(dot);

      // create pulse
      var pulse = document.createElement('div');
      pulse.className = 'pulse';
      holder.appendChild(pulse);

      // append the marker to the map container
      image.chart.chartDiv.appendChild(holder);

      return holder;
}


 }

class Item  {
    label: string;
    value: any;
}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/features/dashboard/world-view-container/world-view-container.component.ts